// src/hooks/useAuth.ts
import { useContext } from 'react';
import { AuthContext, AuthContextType } from '@/contexts/AuthContext';
// console.log("🟨🟩🟪🟥🟦🟫⬛️ Loading <hooks/useAuth>")

/**
 * Custom hook to access the shared authentication state.
 * This hook must be used within a component wrapped by AuthProvider.
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};